var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDebankSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.03 1.69734V6.91006C6.86 7.19006 6 8.33006 6 9.68006C6 11.1701 7.14 12.2901 8.65 12.2901C9.16 12.2901 9.65 12.1501 10.08 11.8801L11.02 12.5401C11.04 13.1001 11.51 13.5501 12.08 13.5501C12.67 13.5501 13.14 13.0701 13.14 12.4901C13.14 11.9101 12.66 11.4301 12.08 11.4301C12 11.4301 11.93 11.4401 11.85 11.4601L11.03 10.8801C11.25 10.4801 11.36 10.0401 11.36 9.58006C11.36 8.39006 10.55 7.32006 9.4 6.96006V1.58008C13.739 1.59474 15.2024 3.99643 15.99 6.09001C16.3 6.90001 16.75 7.78001 17.15 8.55001C17.77 9.75001 18.09 10.39 18.03 10.8C17.95 11.55 16.79 12.05 16.26 12.25V13.56C16.27 13.61 16.28 14.85 15.11 15.59C14.4 16.04 13.65 16.14 13.22 16.15V17.93C13.19 18.1 13 18.43 12.51 18.43L4.87001 18.44C4.52001 18.44 4.32001 18.16 4.26001 17.99L4.24001 17.94V14.58C4.24001 14.41 3.98001 13.97 3.72001 13.55C3.01001 12.39 1.95001 10.63 1.95001 8.23001C1.95001 5.79624 4.28089 2.37043 8.03 1.69734ZM9.89999 9.65008C9.89999 10.3404 9.34035 10.9001 8.64999 10.9001C7.95964 10.9001 7.39999 10.3404 7.39999 9.65008C7.39999 8.95972 7.95964 8.40008 8.64999 8.40008C9.34035 8.40008 9.89999 8.95972 9.89999 9.65008Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebankSupport);
export default __webpack_public_path__ + "static/media/debank-support.fb0cb4495203ccb44a072d9e35ba0eec.svg";
export { ForwardRef as ReactComponent };